import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import {
  VascoAuthIcon,
  VascoSuccessIcon,
  VascoFailIcon,
  CallDeskPhoneIcon,
} from '../../../components/common/icons';

class VascoLock extends PureComponent {
  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
  }
  handleClose() {
    this.props.vascoauthentication.onClose();
  }

  onLogout(){
    window.location.reload();
  }

  render() {
    const {
      i18n: { messages },
    } = this.props;

    return (
      <div className="scene">
        <div className="row vasco">
          <div className="columns small-12 text-center">
            <div className="module">
              <div>
                <div className="flexClass pad-bottom-40">
                  <VascoFailIcon color={'#fff'} />
                </div>
                <div className="pad-bottom-40" tabIndex={0}>
                  <Text style={{ color: '#ffffff' }}>
                    {messages[this.props.instructionsMsgId]}
                  </Text>
                </div>
              </div>
              <div className="row">
                <div className="small-12 column center ">
                  <Button fullWidth onPress={this.onLogout}>
                    {messages['app.vasco.ch.call.rm.button']}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    vascoauthentication: {
      onClose: { $call: 'vascoClose' },
      otpStatus: true,
    },

    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },
    auth: {
      onClose: { $call: 'login' },
      onLogout: { $call: 'logout' },
    },
  },
})(VascoLock);
